import { render, staticRenderFns } from "./zxtixian.vue?vue&type=template&id=0a7bde4e&scoped=true&"
import script from "./zxtixian.vue?vue&type=script&lang=js&"
export * from "./zxtixian.vue?vue&type=script&lang=js&"
import style0 from "./zxtixian.vue?vue&type=style&index=0&id=0a7bde4e&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7bde4e",
  null
  
)

export default component.exports